(function () {
  'use strict';

  /*
    Headboard size -> gallery image (alt-tag matching).

    When a customer selects a headboard size, this shows the matching product
    image in the main gallery. The selected color and headboard option value
    are handleized and matched against each gallery thumbnail's alt text.
    Example:
      Silver Plush Velvet + 60" Inches Tall Headboard
      matches silver-plush-velvet-60-inches-tall-headboard
  */

  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getSelectedHeadboardButton() {
    return (
      document.querySelector('.headboard-opt.is-selected') ||
      document.querySelector('.headboard-opt[aria-pressed="true"]')
    );
  }

  function getSelectedHeadboardValue() {
    var btn = getSelectedHeadboardButton();
    return btn ? (btn.getAttribute('data-option-value') || '') : '';
  }

  function getSelectedColorValue() {
    var selectedColor =
      document.querySelector('.color-opts-grid.is-active .color-opt.is-selected') ||
      document.querySelector('.color-opts-grid.is-active .color-opt[aria-pressed="true"]') ||
      document.querySelector('.color-opt.is-selected') ||
      document.querySelector('.color-opt[aria-pressed="true"]');

    if (selectedColor) {
      return selectedColor.getAttribute('data-option-value') || '';
    }

    var currentLabels = document.querySelectorAll('[data-product-color-current], [data-tab-current]');
    for (var i = 0; i < currentLabels.length; i++) {
      var label = (currentLabels[i].textContent || '').trim();
      if (label && !/headboard|storage|drawer|ottoman|size|single|double|king|ft\b/i.test(label)) {
        return label;
      }
    }

    return '';
  }

  function getThumbAltHandle(thumb) {
    var alt = thumb.getAttribute('data-image-alt') || '';
    if (!alt && thumb.querySelector('img')) {
      alt = thumb.querySelector('img').getAttribute('alt') || '';
    }
    return handleize(alt);
  }

  function getThumbsVisibleFirst() {
    var thumbs = Array.prototype.slice.call(
      document.querySelectorAll('[data-gallery-thumb]:not([data-static-thumb])')
    );

    return thumbs.sort(function (a, b) {
      return Number(a.hidden) - Number(b.hidden);
    });
  }

  function findByAlt(thumbs, predicate) {
    for (var i = 0; i < thumbs.length; i++) {
      var handle = getThumbAltHandle(thumbs[i]);
      if (handle && predicate(handle)) return thumbs[i];
    }
    return null;
  }

  function findHeadboardThumb(sizeValue) {
    if (!sizeValue) return null;

    var headboardTarget = handleize(sizeValue);
    var colorTarget = handleize(getSelectedColorValue());
    var combinedTarget = colorTarget ? colorTarget + '-' + headboardTarget : '';
    var sizeNumber = (String(sizeValue).match(/\d+/) || [])[0] || '';
    var thumbs = getThumbsVisibleFirst();

    if (combinedTarget) {
      var exactCombined = findByAlt(thumbs, function (handle) {
        return handle === combinedTarget || handle.indexOf(combinedTarget) !== -1;
      });
      if (exactCombined) return exactCombined;
    }

    var exactHeadboard = findByAlt(thumbs, function (handle) {
      return handle === headboardTarget;
    });
    if (exactHeadboard) return exactHeadboard;

    if (colorTarget && sizeNumber) {
      var colorSizeMatch = findByAlt(thumbs, function (handle) {
        return handle.indexOf(colorTarget + '-') !== -1 &&
          /headboard|tall|inch|height/.test(handle) &&
          handle.indexOf(sizeNumber) !== -1;
      });
      if (colorSizeMatch) return colorSizeMatch;
    }

    if (!sizeNumber) return null;
    return findByAlt(thumbs, function (handle) {
      return /headboard|tall|inch|height/.test(handle) && handle.indexOf(sizeNumber) !== -1;
    });
  }

  function setMainImage(thumb) {
    var main = document.querySelector('[data-gallery-main-image]');
    if (!main) return;

    thumb.hidden = false;

    if (typeof thumb.click === 'function') {
      thumb.click();
      return;
    }

    document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      var isActive = t === thumb;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    var src = thumb.getAttribute('data-image-src');
    var srcset = thumb.getAttribute('data-image-srcset');
    var alt = thumb.getAttribute('data-image-alt') || '';

    if (src) {
      main.classList.add('is-loading');
      main.src = src;
      if (srcset) main.srcset = srcset;
      main.alt = alt;

      var finish = function () {
        main.classList.remove('is-loading');
        main.removeEventListener('load', finish);
        main.removeEventListener('error', finish);
      };
      main.addEventListener('load', finish);
      main.addEventListener('error', finish);
    }
  }

  var headboardMode = false;
  var lastHeadboardValue = '';
  var scheduled = false;

  function activate() {
    scheduled = false;

    var sizeValue = lastHeadboardValue || getSelectedHeadboardValue();
    if (!headboardMode || !sizeValue) return;

    var thumb = findHeadboardThumb(sizeValue);
    if (!thumb) return;

    setMainImage(thumb);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;

    // Re-apply after the theme's own gallery and server-rendered variant updates.
    setTimeout(activate, 60);
    setTimeout(activate, 220);
    setTimeout(activate, 500);
    setTimeout(activate, 900);
    setTimeout(activate, 1400);
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var headboardBtn = event.target.closest('.headboard-opt');
    if (headboardBtn) {
      headboardMode = true;
      lastHeadboardValue = headboardBtn.getAttribute('data-option-value') || '';
      schedule();
      return;
    }

    if (event.target.closest('.color-opt, .opt-card, .storage-opt, [data-color-option], [data-option-value-id]')) {
      lastHeadboardValue = getSelectedHeadboardValue();
      if (lastHeadboardValue) {
        headboardMode = true;
        schedule();
      }
    }
  }, true);

  document.addEventListener('variant:change', schedule);

  function init() {
    lastHeadboardValue = getSelectedHeadboardValue();
    if (lastHeadboardValue) {
      headboardMode = true;
      schedule();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
